import { ReactNode } from 'react';

import { Content, Root, recordAttendanceDrawerStepperClasses } from './styles';
import useRecordAttendanceDrawerStepper, { EnumOrObject, UseRecordAttendanceDrawerStepper } from './vm';

export interface RecordAttendanceDrawerStepperProps<Steps extends EnumOrObject<any>>
  extends UseRecordAttendanceDrawerStepper<Steps> {
  header: ReactNode;
  children: (stepperProps: {
    currentStep: Steps[keyof Steps];
    goToStep: (step: Steps[keyof Steps]) => void;
    goToPreviousStep: () => void;
    goToNextStep: () => void;
  }) => ReactNode;
}

const RecordAttendanceStepper = <Steps extends EnumOrObject<any>>({
  header,
  children,
  ...vmProps
}: RecordAttendanceDrawerStepperProps<Steps>) => {
  const { steps } = vmProps;
  const { currentStep, goToStep, goToPreviousStep, goToNextStep } = useRecordAttendanceDrawerStepper(vmProps);

  const stepValues = Object.values(steps);
  /** Type casting just for outer world to believe that they are getting correct type */
  const currentStepValue = stepValues.indexOf(currentStep) as Steps[keyof Steps];

  return (
    <Root>
      {header}
      <Content className={recordAttendanceDrawerStepperClasses.content}>
        {children({ currentStep: currentStepValue, goToStep, goToPreviousStep, goToNextStep })}
      </Content>
    </Root>
  );
};

export default RecordAttendanceStepper;
